import { Tooltip as TooltipPrimitive } from 'radix-ui';
import type { ReactNode } from 'react';

/**
 * Подсказка. В прототипе подсказки — атрибут title; в продукте — доступная подсказка Radix
 * в стиле тоста (wine-ink, rail-text 12).
 */
export const TooltipProvider = TooltipPrimitive.Provider;

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export function Tooltip({ content, children, side = 'top' }: TooltipProps) {
  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className="z-70 max-w-280 rounded-8 bg-wine-ink px-10 py-6 text-[12px] leading-[16px] text-rail-text shadow-toast animate-rise-menu"
        >
          {content}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
